import React, { useEffect } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';

import HomePage from './components/Wiki';
import EscapeProtocolWiki from './components/EscapePWiki';

const pages = {
  '/': HomePage,
  '/escape-protocol': EscapeProtocolWiki,
};

// Animation variants for page transitions
const pageVariants = {
  initial: {
    opacity: 0,
    x: -50
  },
  in: {
    opacity: 1,
    x: 0
  },
  out: {
    opacity: 0,
    x: 50
  }
};

// FUCKING PUSH ME

console.log("FUCKING PUSH ME :(");

const pageTransition = {
  type: 'tween',
  ease: 'anticipate',
  duration: 0.3
};

// Define PageComponent that renders the appropriate page
const PageComponent = ({ pathname }) => {
  const Component = pages[pathname] || HomePage; // Default to HomePage if route not found
  
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
      className="w-full"
    >
      <Component />
    </motion.div>
  );
};

const TransitionWrapper = () => {
  const location = useLocation();
  
  return (
    <div className="relative min-h-screen">
      <AnimatePresence mode="wait">
        <PageComponent pathname={location.pathname} key={location.pathname} />
      </AnimatePresence>
    </div>
  );
};

const App = () => {
  useEffect(() => {
    const preventZoom = (e) => {
      if ((e.ctrlKey || e.metaKey) && (e.key === '+' || e.key === '-')) {
        e.preventDefault();
      }
    };
    const preventWheelZoom = (e) => {
      if (e.ctrlKey && e.type === 'wheel') e.preventDefault();
    };
    document.addEventListener('keydown', preventZoom);
    document.addEventListener('wheel', preventWheelZoom, { passive: false });
    return () => {
      document.removeEventListener('keydown', preventZoom);
      document.removeEventListener('wheel', preventWheelZoom);
    };
  }, []);

  return (
    <Router>
      <TransitionWrapper />
    </Router>
  );
};

export default App;